import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '../components/LoginPage';
import DashboardLayout from '../components/DashboardLayout';
import Overview from '../components/Overview';
import QueueDetails from '../components/QueueDetails';
import JobBrowser from '../components/JobBrowser';
import AIProvidersPage from '../components/AIProvidersPage';
import AIEmbeddingProvidersPage from '../components/AIEmbeddingProvidersPage';
import AIUsagePage from '../components/AIUsagePage';
import WebhookFlowDiagnostics from '../components/WebhookFlowDiagnostics';
import FeatureFlagsPage from './FeatureFlagsPage';
import SearchLogPage from './SearchLogPage';
import CatalogSyncPage from '../components/CatalogSyncPage';
import AdminPlansPage from '../components/AdminPlansPage';
import AdminBetaInterestPage from '../components/AdminBetaInterestPage';
import DebugLogsPage from './DebugLogsPage';
import AdminNodesPage from '../components/AdminNodesPage';
import LiveWebhookInspector from '../components/LiveWebhookInspector';
import { AuthProvider, useAuth } from '../contexts/AuthContext';
import { ToastProvider } from '../contexts/ToastContext';
import '../styles/monitoring.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner"></div>
        <p>Cargando...</p>
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/admin/login" replace />;
};

const AdminDashboard: React.FC = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <div className="admin-monitoring-app">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={
              <ProtectedRoute>
                <DashboardLayout>
                  <Routes>
                    <Route path="/" element={<Overview />} />
                    <Route path="/queue/:queueName" element={<QueueDetails />} />
                    <Route path="/jobs" element={<JobBrowser />} />
                    <Route path="/diagnostics" element={<WebhookFlowDiagnostics />} />
                    <Route path="/webhooks" element={<LiveWebhookInspector />} />
                    <Route path="/ai-providers" element={<AIProvidersPage />} />
                    <Route path="/embedding-providers" element={<AIEmbeddingProvidersPage />} />
                    <Route path="/ai-usage" element={<AIUsagePage />} />
                    <Route path="/feature-flags" element={<FeatureFlagsPage />} />
                    <Route path="/search-log" element={<SearchLogPage />} />
                    <Route path="/debug-logs" element={<DebugLogsPage />} />
                    <Route path="/catalog-sync" element={<CatalogSyncPage />} />
                    <Route path="/nodes" element={<AdminNodesPage />} />
                    <Route path="/plans" element={<AdminPlansPage />} />
                    <Route path="/beta-interest" element={<AdminBetaInterestPage />} />
                    <Route path="/bot-settings" element={<Navigate to="/app/bot-settings/escalation" replace />} />
                    <Route path="/bot-settings/*" element={<Navigate to="/app/bot-settings/escalation" replace />} />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </ToastProvider>
    </AuthProvider>
  );
};

export default AdminDashboard;
